import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./TestimonialsCarousel.css";

const testimonials = [
  {
    review:
      "Creating my portfolio through AceTechies Academy was one of the best decisions! The design templates are modern and responsive.",
    name: "Ananya Gupta",
    position: "Frontend Developer",
    company: "TCS",
  },
  {
    review:
      "Loved how simple yet powerful the portfolio builder is. I could customize everything and launch in minutes!",
    name: "Rohan Mehta",
    position: "Software Engineer",
    company: "Infosys",
  },
  {
    review:
      "The animations and layout options are top-notch. My LinkedIn engagement increased drastically after using it.",
    name: "Priya Sharma",
    position: "UI/UX Designer",
    company: "Zoho",
  },
];

export default function TestimonialsCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const nextSlide = () => {
    setDirection(1);
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  const current = testimonials[index];

  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 150 : -150,
      opacity: 0,
    }),
    center: {
      x: 0,
      opacity: 1,
    },
    exit: (direction) => ({
      x: direction < 0 ? 150 : -150,
      opacity: 0,
    }),
  };

  return (
    <div className="testimonial-container">
      <AnimatePresence mode="wait" custom={direction}>
        <motion.div
          key={index}
          className="testimonial-card"
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          <p className="testimonial-review">
            <em className="testimonial-quote">“{current.review}”</em>
          </p>
          <p className="testimonial-user">
            — {`${current.name}, ${current.position}, ${current.company}`}
          </p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}
